import React from 'react';
import { Check, WifiOff, XCircle } from 'lucide-react';
type SaveStatus = 'saving' | 'saved' | 'saved_ago' | 'offline' | 'error';
interface AutosaveIndicatorProps {
  status: SaveStatus;
  minutesAgo?: number;
}
export function AutosaveIndicator({
  status,
  minutesAgo = 0
}: AutosaveIndicatorProps) {
  switch (status) {
    case 'saving':
      return <span className="flex items-center gap-1 text-secondary text-xs" data-id="element-971">
          <div className="w-3 h-3 border-2 border-secondary border-t-transparent rounded-full animate-spin" data-id="element-972" />
          Saving...
        </span>;
    case 'saved':
      return <span className="flex items-center gap-1 text-secondary text-xs" data-id="element-973">
          <Check className="w-3 h-3" data-id="element-974" /> Saved just now
        </span>;
    case 'saved_ago':
      return <span className="flex items-center gap-1 text-secondary text-xs" data-id="element-975">
          <Check className="w-3 h-3" data-id="element-976" /> Last saved {minutesAgo}m ago
        </span>;
    case 'offline':
      return <span className="flex items-center gap-1 text-amber-600 text-xs" data-id="element-977">
          <WifiOff className="w-3 h-3" data-id="element-978" /> Offline - pending sync
        </span>;
    case 'error':
      return <span className="flex items-center gap-1 text-destructive text-xs" data-id="element-979">
          <XCircle className="w-3 h-3" data-id="element-980" /> Save failed
        </span>;
  }
}